import { put, takeLatest } from 'redux-saga/effects';
import {
    FETCH_USER_LOCALE,
} from '../../actions/actionTypes';
import {
    SET_SELECTED_LANGUAGE,
} from '../../shared/actions/actionTypes';
import { setI18nConfig } from '../../shared/translations';
import { USER_LOCALE } from '../../shared/constants/LocalStorageKeys/LocalStorageKeys';

export function* requestUserLocale() {
    const fetchResponse = yield fetch('/users/getUserLocale');
    const languageTag = yield fetchResponse.json();
    localStorage.setItem(USER_LOCALE, languageTag);
    yield setI18nConfig(languageTag);
    yield put({ type: SET_SELECTED_LANGUAGE, selectedLocale: languageTag });
}

export default function* watchRequestUserLocale() {
    yield takeLatest(FETCH_USER_LOCALE, requestUserLocale);
}
